import React from 'react';
import css from './css.less';
import { Button } from 'src/components/Antd';
const BGBtn = (props) => {
  const { checked, className, children, ...rest } = props;

  return (
    <Button
      className={`${checked ? css.checked : css.btn} ${className || ''}`}
      {...rest}>
      {children}
    </Button>
  );
};
export default BGBtn;
